import { Controller } from "@hotwired/stimulus"

// Handles Bootstrap tab navigation via URL hash
// Replaces: app/assets/javascripts/link_to_tab.js
//
// Features:
// - Shows tab based on URL hash on page load (e.g., #tab-name)
// - Updates URL hash when tab changes
//
// Usage:
//   <ul class="nav nav-tabs" data-controller="tab-hash">
//     <li class="nav-item">
//       <a class="nav-link" data-bs-toggle="tab" href="#tab1"
//          data-action="shown.bs.tab->tab-hash#updateHash">Tab 1</a>
//     </li>
//   </ul>
//
// Or apply to individual tab links:
//   <a data-controller="tab-hash"
//      data-action="shown.bs.tab->tab-hash#updateHash"
//      data-bs-toggle="tab" href="#tab1">Tab 1</a>
export default class extends Controller {
  connect() {
    // On page load, check if hash matches this tab and activate it
    const hash = window.location.hash

    if (hash && this.element.getAttribute('href') === hash) {
      this.showTab()
    }
  }

  // Called when tab is shown (via Bootstrap event)
  updateHash(event) {
    window.location.hash = event.target.hash
  }

  // Show this tab using Bootstrap 5 vanilla JS API
  showTab() {
    const tab = new bootstrap.Tab(this.element)
    tab.show()
  }
}
